export default __webpack_public_path__ + "static/media/moon.6f6563a0.svg";